module.exports = __webpack_public_path__ + "img/ad21c4b.svg";